import validate from "/app/node_modules/.pnpm/nuxt@3.17.5_@parcel+watcher@2.5.1_@types+node@22.15.17_bufferutil@4.0.9_db0@0.3.2_encoding@0._q4b54onnmrdqmozxybegq2yntu/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@3.17.5_@parcel+watcher@2.5.1_@types+node@22.15.17_bufferutil@4.0.9_db0@0.3.2_encoding@0._q4b54onnmrdqmozxybegq2yntu/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}